import React from 'react'
import './location.css'
import { FiMapPin, FiPhone, FiMail  } from "react-icons/fi";

function Location({language, reference}) {
    return (
        <section className='location_section' ref={reference}>
            <div className='location_container'>
                <div style={{flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '25px'}}>
                    <p style={{fontSize: '2rem'}}>{language === 'deutsch' ? 'Kontakt' : 'Contact'}</p>
                    <p><FiMapPin style={{color: '#fca311'}}/> 105 Buckesfelder Str. Lüdenscheid, 58509 North Rhine-Westphalia</p>
                    <p><FiPhone style={{color: '#fca311'}}/> +49 (0) 2674 / 6847241</p>
                    <p><FiMail style={{color: '#fca311'}}/> contact@domain.eu</p>
                </div>
                <div className='map_container'>
                    <iframe
                        title="Google Map"
                        width="100%"
                        height="600"
                        frameBorder="0"
                        scrolling="no"
                        marginHeight="0"
                        marginWidth="0"
                        src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=105%20Buckesfelder%20Str.%20L%C3%BCdenscheid,%20North%20Rhine-Westphalia+(OurLocation)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                        allowFullScreen="0"
                        style={{borderRadius: '16px', boxShadow:'0 4px 30px rgba(0, 0, 0, 0.1)'}}
                    ></iframe>
                </div>
            </div>
        </section>
    )
}

export default Location